export const AUTH_ERROR_CODES = {
	GOVERNMENT_IMPEDIMENTO: "GovernmentImpedimento",
	GOVERNMENT_IMPEDIMENTO_UNAVAILABLE: "GovernmentImpedimentoUnavailable",
	MISSING_NATIONAL_ID: "MissingNationalId",
};

export const IMPEDIMENTO_MOTIVO_KEYS = {
	PROGRAMA_SOCIAL: "auth.impedimento.motivos.PROGRAMA_SOCIAL",
	AUTOEXCLUSAO_CENTRALIZADA: "auth.impedimento.motivos.AUTOEXCLUSAO_CENTRALIZADA",
	PROGRAMA_NOVO_DESENROLA_BRASIL: "auth.impedimento.motivos.PROGRAMA_NOVO_DESENROLA_BRASIL",
	RENEGOCIACAO_FIES: "auth.impedimento.motivos.RENEGOCIACAO_FIES",
};

export const parseAuthError = (error) => {
	const data = error?.data || error?.response?.data || error?.error?.data || {};
	const status =
		error?.status ||
		error?.response?.status ||
		error?.error?.status ||
		error?.originalStatus;

	return {
		code: data.code,
		message: data.message || data.Message,
		motivos: Array.isArray(data.motivos) ? data.motivos : [],
		resultado: data.resultado,
		status,
	};
};

export const isGovernmentImpedimentoError = (error) => {
	const { code } = parseAuthError(error);

	return code === AUTH_ERROR_CODES.GOVERNMENT_IMPEDIMENTO;
};

export const isGovernmentImpedimentoUnavailableError = (error) => {
	const { code, status } = parseAuthError(error);

	return (
		code === AUTH_ERROR_CODES.GOVERNMENT_IMPEDIMENTO_UNAVAILABLE ||
		(status === 503 && code === AUTH_ERROR_CODES.GOVERNMENT_IMPEDIMENTO_UNAVAILABLE)
	);
};

export const formatImpedimentoMotivos = (motivos, translate) => {
	if (!Array.isArray(motivos) || motivos.length === 0) {
		return "";
	}

	return motivos
		.map((motivo) => {
			const key = IMPEDIMENTO_MOTIVO_KEYS[motivo];

			return key && translate ? translate(key) : motivo;
		})
		.join(", ");
};

export const buildImpedimentoAlertMsgParams = (msgParams, translate) => {
	if (!msgParams?.motivoCodes) {
		return msgParams;
	}

	const { motivoCodes, ...rest } = msgParams;

	return {
		...rest,
		motivos: formatImpedimentoMotivos(motivoCodes, translate),
	};
};

export const getGovernmentImpedimentoAlertPayload = (error) => {
	const { motivos } = parseAuthError(error);

	return {
		type: "error",
		title: "GOVERNMENT_IMPEDIMENTO_TITLE",
		msg: "GOVERNMENT_IMPEDIMENTO",
		msgParams: {
			motivoCodes: motivos,
		},
	};
};

export const getGovernmentImpedimentoUnavailableAlertPayload = () => ({
	type: "error",
	title: "ERROR",
	msg: "GOVERNMENT_IMPEDIMENTO_UNAVAILABLE",
});

export const getAuthErrorAlertPayload = (error) => {
	if (isGovernmentImpedimentoError(error)) {
		return getGovernmentImpedimentoAlertPayload(error);
	}

	if (isGovernmentImpedimentoUnavailableError(error)) {
		return getGovernmentImpedimentoUnavailableAlertPayload();
	}

	return null;
};
